

import { mapStores } from "pinia";
import { defineComponent } from "vue";
import basePage from "~/core/base-page";
import { useAuthStore } from "~/store/auth.store";

export default defineComponent({

    extends: basePage,

    data() {
        return {
            showPassword: false,
            login: '',
            password: '',
            failed: false,
            isLoading: false,
        };
    },

    computed: {
        ...mapStores(useAuthStore),
        logo() {
            return require('../../img/elichens-logo-600px.png').default
        },
        userImg() {
            return require('../../img/profile-pic.png').default
        }
    },
    mounted() {
        if (this.authStore.isLogged) {
            this.$router.push('/dashboard');
        }
    },

    methods: {
        async onSubmit(e: Event) {
            e.preventDefault();
            await this.authStore.logout();
            this.failed = false;
            this.isLoading = true;
            this.authStore.login(this.login, this.password).then(() => this.$router.push('/dashboard'))
                .catch(() => {
                    this.failed = true;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        togglePasswordVisibility(): void {
            this.showPassword = !this.showPassword;
        }
    }

});

